import { render, staticRenderFns } from "./WorkforceListing.vue?vue&type=template&id=4427876f&"
import script from "./WorkforceListing.vue?vue&type=script&lang=js&"
export * from "./WorkforceListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports